export default __webpack_public_path__ + "static/media/denied-img.c8841feb.svg";